import React from "react";

const Footer = () => {
  return (
    <footer className="footer">
      <h5 className="copyright">
        &copy; 2022. Designed and Built by <span>Osifo John</span>
      </h5>
    </footer>
  );
};

export default Footer;
